<template>
	<div class="container-md mh-100">
		<LayoutHeaderSection>
			<template #title>
				<LayoutTextSection text="Configuración de la empresa" :breadcrumb="true" />
			</template>
			<template #actions>
				<div class="hstack gap-2 justify-content-md-end">
					<CommonButtonCompanyAdminSettingOption />
				</div>
			</template>
		</LayoutHeaderSection>
		<main class="pt-8 vstack gap-10">
			<CommonFormWrapper submitText="Guardar" :cancelUrl="{ name: 'company.admin.home' }" :submitting="submitting" :errors="validationExternal" @submit="submit">
				<template #body>
					<CommonFormInputAmount v-model="form.config.commission" title="Comisión por venta" info="Asigna comisiones por cada venta, independientemente de las metas." step="0.01" subtitle="Porcentaje" placeholder="Ingrese un porcentaje de comisión" :validation="validation.config.commission" />
					<hr class="my-0">
					<h5>Desasignación automática de clientes</h5>
					<CommonFormInputSelect v-model="form.config.user_unassign.type" title="Método de desasignación" info="Es el método con el cual la plataforma desasignará a los clientes de sus vendedores." :options="$env.MODEL.Company.config.user_unassign.types" :validation="validation.config.user_unassign.type" />
					<CommonFormInputNumber v-model="form.config.user_unassign.days" title="Cantidad de días antes de desasignar al cliente" info="Es la cantidad de días máximos antes de desasignar al cliente." placeholder="Ingrese la cantidad de días" :validation="validation.config.user_unassign.days" v-if="form.config.user_unassign.type == 'days'" />
					<CommonFormInputSelect v-model="form.config.user_unassign.sell" title="¿Si se concretó una venta?" info="Es la acción que permite desasignar (o no) un cliente de un vendedor, en caso de que se haya concretado una venta." :options="{ 1: 'Desasignar de todas maneras', 0: 'No desasignar cliente' }" :validation="validation.config.user_unassign.sell" v-if="form.config.user_unassign.type == 'days'" />
					<hr class="my-0">
					<h5>Asignación de las ventas a los vendedores</h5>
					<CommonFormInputSelect v-model="form.config.sale_assign.type" title="Método de asignación" info="Es el método que se utiliza para asignarle las ventas a un vendedor." :options="$env.MODEL.Company.config.sale_assign.types" />
					<CommonFormInputNumber v-model="form.config.sale_assign.hours" title="Cantidad de horas" info="Es la cantidad de horas máximas desde la última interacción registrada por el vendedor." placeholder="Ingrese la cantidad de horas" :validation="validation.config.sale_assign.hours" v-if="form.config.sale_assign.type == 'interacted'" />
					<hr class="my-0">
					<h5>Otras configuraciones</h5>
					<CommonFormInputNumber v-model="form.config.reconquest.days" title="Reconquista de cliente" info="Es la cantidad de días a partir de los cuales se considera que el cliente ha sido reconquistado si se registra una venta." placeholder="Ingrese la cantidad de días" :validation="validation.config.reconquest.days" />
				</template>
			</CommonFormWrapper>
		</main>
	</div>
</template>

<script>
	import { reactive, computed } from 'vue';
	import router from '@/router';
	import store from '@/store';
	import _ from 'lodash';
	import useVuelidate from '@vuelidate/core';
	import { helpers } from '@vuelidate/validators';
	import { requiredIf, minValue, maxValue } from '@/helpers/i18n/validators';
	import composableForm from '@/composables/form';
	import CompanyAdminCompanyRepository from '@/repositories/modules/Company/Admin/Company';

	export default {
		setup() {
			const { submitting, validationExternal, catchError } = composableForm();
			const company = computed(() => store.getters['company/info']);

			const form = reactive({
				config: {
					commission: company.value?.config?.commission ?? null,
					user_unassign: {
						type: company.value?.config?.user_unassign?.type ?? 'none',
						days: company.value?.config?.user_unassign?.days ?? null,
						sell: company.value?.config?.user_unassign?.sell ?? '0'
					},
					sale_assign: {
						type: company.value?.config?.sale_assign?.type ?? 'interacted',
						hours: company.value?.config?.sale_assign?.hours ?? null
					},
					reconquest: {
						days: company.value?.config?.reconquest?.days ?? null
					}
				}
			});

			const validation = useVuelidate({
				config: {
					commission: {
						minValue: minValue(0),
						maxValue: maxValue(100)
					},
					user_unassign: {
						days: {
							requiredIf: requiredIf(() => form.config.user_unassign.type == 'days'),
							minValue: minValue(1)
						}
					},
					sale_assign: {
						hours: {
							requiredIf: requiredIf(() => form.config.sale_assign.type == 'interacted'),
							minValue: minValue(1)
						}
					},
					reconquest: {
						days: {
							minValue: minValue(1)
						}
					}
				}
			}, form);

			const submit = async () => {
				if(submitting.value) return;
				validationExternal.value = [];
				if(!await validation.value.$validate()) return;

				submitting.value = true;
				await CompanyAdminCompanyRepository.config(form).then((response) => {
					store.dispatch('company/setInfo', response.data);
					router.push({ name: 'company.admin.home' });
				}).catch(catchError);
				submitting.value = false;
			}

			return { form, submit, submitting, validation, validationExternal };
		}
	}
</script>